import React from 'react';

const Banner = (props) => (
  <div
    style={{ width: '100%' }}
    className="flex items-center justify-center p1 center bg-black-tint-20 text-black-tint-90 secondary-font h6"
    {...props}
  />
);

export default Banner;
